module.exports = __webpack_public_path__ + "static/media/jolly.c149d314.jpg";